// AdminController inherits ApplicationController's protect_from_forgery
// with: :null_session, so every mutating request from this board needs the
// token or the session gets silently dropped (see index.jsx for the fallout).
const csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.content;

export default csrfToken;
